import React from "react";
// used for making the prop types of this component
import PropTypes from "prop-types";
import Moment from 'moment';

import useGlobal from "../../store";

import DateRangeInput from "./DateRangeInput";
import OperationSelect from "./OperationSelect";
import VisitSelect from "./VisitSelect";
import ActiveVisits from "./ActiveVisits";
import ClosedVisits from "./ClosedVisits";
import VisitsHistory from "./VisitsHistory";
import Button from "components/Button";
import history from '../../utils/history';
import { useTranslation } from "react-i18next";

function FiltersSidebar({activeVisitAnswer, visits, visitAnswers, operators, closedVisitAnswer}){
  const [filters, globalActions] = useGlobal(
    state => state.filters,
    actions => actions
  );

  let closedVisitsAnswers = [];

  const { loadingVisitAnswersClosed, dataVisitAnswer } = visitAnswers;

  if (!loadingVisitAnswersClosed) {
    if (dataVisitAnswer) {
      closedVisitsAnswers = dataVisitAnswer.map((visitAnswer) => ({...visitAnswer, checkOutDate: Moment(visitAnswer.checkOutDate)}));;
    }
  }
  /* const closedVisitsAnswers = 
    visitAnswers
      .map((visitAnswer) => ({...visitAnswer, checkOutDate: Moment(visitAnswer.checkOutDate)})); */

  const visitSelectChange = React.useCallback((value) => {
    globalActions.filters.setVisitID(value);
    globalActions.filters.setOperation(null);
  }, [globalActions])

    const handleNavigation = (reportURL) => {
    history.push(`/visits/${filters.selectedVisitID.value}/${reportURL}`);
  }
  const { t } = useTranslation("general_adaptation");

  return (
    <React.Fragment>
      <VisitSelect
        visitsIDs={visits}
        selectedVisitID={filters.selectedVisitID}
        setVisitID={visitSelectChange}
      />
      <OperationSelect
        operations={operators}
        selectedOperation={filters.selectedOperation}
        setOperation={globalActions.filters.setOperation}
      />
      <DateRangeInput
        startDate={filters.range.startDate}
        endDate={filters.range.endDate}
        setStartDateRange={globalActions.filters.setStartDateRange}
        setEndDateRange={globalActions.filters.setEndDateRange}
      />
      <div style={{ "margin-bottom": "10px", marginTop: "10px" }}>
        <Button
          button={false}
          size="md"
          color="beepquest"
          fullWidth
          onClick={() => handleNavigation("histogram")}
        >
          {t("btn_2")}
        </Button>
      </div>
      <div style={{ "margin-bottom": "10px" }}>
        <Button
          button={false}
          size="md"
          color="beepquest"
          fullWidth
          onClick={() => handleNavigation("adminData")}
        >
          {t("btn_3")}
        </Button>
      </div>      
    
    </React.Fragment>
  );
}

FiltersSidebar.propTypes = {
  activeVisitAnswer: PropTypes.object.isRequired,
  visits: PropTypes.array.isRequired,
  visitAnswers: PropTypes.object.isRequired,
  operators: PropTypes.array.isRequired,
};

export default FiltersSidebar;